import { render, staticRenderFns } from "./TagPager.vue?vue&type=template&id=33854158&scoped=true&"
import script from "./TagPager.vue?vue&type=script&lang=js&"
export * from "./TagPager.vue?vue&type=script&lang=js&"
import style0 from "./TagPager.vue?vue&type=style&index=0&id=33854158&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33854158",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSnackbar,VTextField})
